import { VectorLayer } from './Layer';
import { useEffect, useState } from 'react';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Style, Icon } from 'ol/style';

const mapMarkerSvg = `<svg width="72" height="72" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path d="M 24.568 69.812 C 4.468 40.712 0.768 37.712 0.768 27.012 C 0.768 12.412 12.668 0.512 27.268 0.512 C 41.868 0.512 53.768 12.412 53.768 27.012 C 53.768 37.712 50.068 40.712 29.968 69.812 C 28.668 71.712 25.868 71.712 24.568 69.812 Z"
    fill="white"></path>
    <circle fill="none" cx="27" cy="28" r="18" stroke="darkgreen" stroke-width="8"></circle>
</svg>`;

const MarkerFeature = (props) => {
    const { x, y } = props;
    const coords = [x, y];

    const iconFeat = new Feature({
        geometry: new Point(coords)
    });

    var iconStyle2 = new Style({
        image: new Icon({
            opacity: 1,
            src: 'data:image/svg+xml;utf8,' + mapMarkerSvg,
            color: '#016c29',
            scale: 0.8
        })
    });

    iconFeat.setStyle(iconStyle2);
    return iconFeat;
};

const MapMarkerLayer = (props) => {
    const { map, zIndex, markerCoords } = props;

    const buildFeatures = (coords) => {
        const output = [];
        for (let mark of coords) {
            let { center } = mark;
            if (center) {
                var marker = MarkerFeature({
                    x: center[0],
                    y: center[1]
                });
                output.push(marker);
            }
        }
        return output;
    };
    const [features, setFeatures] = useState(() => buildFeatures(markerCoords));

    useEffect(() => {
        const newFeatures = buildFeatures(markerCoords);
        setFeatures(newFeatures);
    }, [markerCoords]);

    return <VectorLayer visible={true} title={'map-marker'} className={'marker'} features={features} zIndex={zIndex} map={map} />;
};
export { MapMarkerLayer };
